<template lang="html">
  <div class="container mb-2 card_box">
    <div class="row">
      <div class="col-md-8 m-auto">
        <div class="input-group">
          <label
            for="Search"
            style="display:none;"
          >Search</label>
          <input
            id="Search"
            v-model="text_search_jointeam"
            type="text"
            class="form-control et-gf-search"
            placeholder="Search"
          >
          <span class="input-group-btn">
            <button
              class="btn btn-search rounded-0"
              type="button"
            ><span style="display:none">Search</span></button>
          </span>
        </div>
        <span
          v-if="LoadingSearch"
          class="image_loading_search"
        >
          <img
            src="https://www.gofundraise.com.au/Content/images/loader-orange.gif"
            alt=""
          >
        </span>
        <div
          v-if="ValueEnterSearch"
          v-click-outside="hideAutoCompleteSearchResults"
          class="search_result"
        >
          <ul class="list-unstyled">
            <li
              v-for="(item, index) in res_data_jointeam"
              v-if="index < 3"
              @click="KeyupClickRegion_jointeam(item.CreatorName)"
            >
              {{ item.CreatorName }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row text-center content-team mt-3">
      <div :class="['row w-100 m-auto']">
        <template v-for="page in res_data_jointeam">
          <div
            class="col-md-3 col-6 wow bounceInUp mb-3"
            @click="($store.state.selected_teampage == '' || $store.state.selected_teampage.page.Id != page.Id) ? toComplete(page) : removePageStore()"
          >
            <div
              :title="page.PageTitle"
              :class="['card', ($store.state.selected_teampage != '' && $store.state.selected_teampage.page.Id == page.Id) ? 'card_selected' : '']"
            >
              <span
                v-show="($store.state.selected_teampage != '' && $store.state.selected_teampage.page.Id != page.Id)"
                class="success_hv"
              />
              <span
                v-show="($store.state.selected_teampage != '' && $store.state.selected_teampage.page.Id == page.Id)"
                class="remove_item_card"
              />
              <div class="square_item">
                <div class="content">
                  <div class="table">
                    <div class="table-cell p-4 align-middle">
                      <img
                        class="card-img-top px-1"
                        :src="page.ImagePath"
                        alt="Card image cap"
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <p class="card-text">
                  {{ page.PageTitle }}
                </p>
              </div>
            </div>
          </div>
        </template>
        <div
          v-show="LazyLoading"
          class="lazy-load"
        >
          <img
            src="https://www.gofundraise.com.au/Content/images/loader-orange.gif"
            alt=""
          >
        </div>
      </div>
      <div class="row w-100">
        <div id="scroll-loader-jointeam" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import ClickOutside from 'vue-click-outside';
import GfAnalyticsMixin from '../inc/GfAnalyticsMixin.vue';

export default {
  directives: {
        ClickOutside
  },
  mixins: [GfAnalyticsMixin],
  data(){
    return{
      ValueEnterSearch: false,
      LazyLoading: false,
      LoadingSearch: false,
      text_search_jointeam: '',
      data_jointeam: '',
      page_number: 1
    }
  },
  computed:{
    res_data_jointeam:{
      get: function(){
        return this.data_jointeam;
      },
      set: function(value){
        if(value != null){
          this.data_jointeam = this.data_jointeam.concat(value);
        }
      }
    }
  },
  watch:{
    text_search_jointeam: function(value){
      let vm = this;
      if(value != ''){
        vm.LoadingSearch = true;
        vm.ValueEnterSearch = true;
      }else{
        vm.LoadingSearch = false;
        vm.ValueEnterSearch = false;
      }
      let params_query = {
        params:{
          region:vm.$store.state.region,
          query: vm.text_search_jointeam,
          eventcampaignid: vm.$store.state.selected_event.EventCampaignId
        }
      }
      this.get_data_jointeam(params_query).then(function(res){
        vm.data_jointeam = res.data.Pages;
      }).then(function(){
        vm.LoadingSearch = false;
      });
      this.$store.commit('res_text_search_jointeam',value);
    }
  },
  created(){
    var vm = this;
    this.LazyLoading = true;
    this.text_search_jointeam = this.$store.state.search_join_team;
    let params_query = {
      params:{
        region: vm.$store.state.region,
        query: vm.text_search_jointeam,
        eventcampaignid: vm.$store.state.selected_event.EventCampaignId
      }
    }
    params_query = this.passParamsExternal(params_query);
    this.get_data_jointeam(params_query).then(function(res){
      vm.page_number = res.data.PageNumber + 1;
      vm.data_jointeam = res.data.Pages;
    }).then(function(){
      vm.LazyLoading = false;
      vm.ValueEnterSearch = false;
      vm.scroll_loading_more_data();
    });
  },

  methods:{
    hideAutoCompleteSearchResults: function() {
      this.ValueEnterSearch = false;
    },

    async get_data_jointeam(params_query){
      var data = await axios.get(this.$store.state.apiDomain + '/v1/pages/search?pagetype=T&excludepageswithrestrictedcreation=true',params_query);
      return data;
    },
    passParamsExternal(params_query){
      if(this.$store.state.referrer != ''){
        params_query.params.externalidtype = this.$store.state.referrer;
      }
      if(this.$store.state.externalId != ''){
        params_query.params.externalid = this.$store.state.externalId;
      }
      return params_query;
    },
    scroll_loading_more_data(){
      var self = this;
      $(window).scroll(function() {
        if( $("#scroll-loader-jointeam")[0] ){
          var hT = $('#scroll-loader-jointeam').offset().top,
              hH = $('#scroll-loader-jointeam').outerHeight(),
              wH = $(window).height(),
              wS = $(this).scrollTop();
          if (wS > (hT+hH-wH)){
            if(!self.LazyLoading){
              self.LazyLoading = true;
              let params_query = {
                params: {
                  region: self.$store.state.region,
                  query: self.text_search_jointeam,
                  eventcampaignid: self.$store.state.selected_event.EventCampaignId,
                  pageindex: self.page_number,
                }
              }
              params_query = self.passParamsExternal(params_query);
              self.get_data_jointeam(params_query).then(function(res){
                self.page_number = res.data.PageNumber + 1;
                self.res_data_jointeam = res.data.Pages;
              }).then(function(){
                self.LazyLoading = false;
              })
            }
          }
        }
      });
    },
    KeyupClickRegion_jointeam(CreatorName){
      var self = this;
      let params_query = {
        params:{
          region: self.$store.state.region,
          query: CreatorName,
          eventcampaignid: self.$store.state.selected_event.EventCampaignId,
        }
      }
      params_query = this.passParamsExternal(params_query);
      this.get_data_jointeam(params_query).then(function(res){
        self.text_search_jointeam = res.data.Pages[0].CreatorName;
        self.data_jointeam = res.data.Pages;
      }).then(function(){
        self.ValueEnterSearch = false;
      });
    },

    toComplete(page){            
      this.analytics({
        'event': 'create_page',
        'createType': 'team_member', 
        'stepNumber': '2 of 3',
        'stepName': 'select team',
        'teamId': page.Id
      }); 
      this.$store.commit('change_event', {
        EventCampaignId : page.Event.EventCampaignId, 
        EventName: page.Event.EventName, 
        EventImagePath: page.Event.EventImagePath, 
        EventUrl: page.Event.EventUrl,
        Router_Name: this.$route.name
      });
      this.$store.commit('change_jointeam_data', {page: page, Router_Name: this.$route.name});
      this.$router.push({name: 'complete_jointeam'});      
    },
    removePageStore(){
      this.$store.commit('change_jointeam_data', '');
    }
  }
}
</script>